
/* styles */
require("!!../../../node_modules/.store/extract-text-webpack-plugin@2.1.2/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ce9645c6\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=styles&index=0!./IndexPieChart.vue")

var Component = require("!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=script&index=0!./IndexPieChart.vue"),
  /* template */
  require("!!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ce9645c6\"}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=template&index=0!./IndexPieChart.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/IndexPieChart.vue
// module id = 1769
// module chunks = 1